import { Card, Paper } from "@mui/material";
import { useState } from "react";
import { experimentalStyled as styled } from "@mui/material/styles";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
  textAlign: "left",
}));

export default function Jobs() {
  const [displayFull, setDisplayFull] = useState(false);

  return (
    <>
      {displayFull === false ? (
        <Item
          style={{
            width: "70vw",
            margin: "auto",
            padding: "20px",
            cursor: "pointer",
          }}
          onClick={() => setDisplayFull(true)}
        >
          <h2>Dossierbeheerder | Lauwe </h2>
          We zijn een klein familiekantoor met meer dan 25 jaar ervaring, waar
          je zeker de kans krijgt om goed opgeleid te worden en te groeien in je
          functie. Ben je leergierig en werk je graag zelfstandig ? Ambitieus om
          door te groeien in een bedrijf ? Bij ons is dit allemaal mogelijk !
          <p style={{ textDecoration: "underline", cursor: "pointer" }}>
            Lees meer...
          </p>
        </Item>
      ) : (
        <div style={{ width: "50vw", margin: "auto", marginBottom: "5%" }}>
          <h2>Dossierbeheerder | Lauwe </h2>
          We zijn een klein familiekantoor met meer dan 25 jaar ervaring, waar
          je zeker de kans krijgt om goed opgeleid te worden en te groeien in je
          functie. Ben je leergierig en werk je graag zelfstandig ? Ambitieus om
          door te groeien in een bedrijf ? Bij ons is dit allemaal mogelijk !
          <h3> FUNCTIE</h3>
          We zijn op zoek naar een all-round dossierbeheerder. Je verzorgt de
          dagdagelijkse boekhouding; Je stelt zelfstandig periodieke
          BTW-aangiftes op; Je verzorgt de tussentijdse afsluitingen in overleg
          met de senior dossierbeheerder; Je bereidt de jaarafsluiting voor
          alsook de opmaak van de jaarrekening en de jaarverslagen; Je bereidt
          de fiscale aangiftes voor zoals aangifte vennootschapsbelasting,
          aangifte personenbelasting…; Je geeft eerstelijnsadvies aan de klanten
          <h3>PROFIEL </h3>
          Je hebt een bachelordiploma Accountancy-Fiscaliteit, of gelijkwaardig
          door ervaring. Je denkt en werkt resultaat -en oplossingsgericht. Je
          bent een integer vertrouwenspersoon en kan zelfstandig werken. Je kan
          goed functioneren in een klein team en houdt van een persoonlijke
          aanpak. Je bent communicatief en vindt het fijn om klanten bij te
          staan met jouw ervaring en kennis.
          <h3>AANBOD </h3>
          We zorgen voor een stimulerend en uitgebreid salarispakket en
          extralegale voordelen, afhankelijk van jouw kennis en ervaring. We
          bieden een veelzijdige job met een divers cliënteel in een
          gedigitaliseerde en flexibele werkomgeving. Persoonlijke groei vinden
          we belangrijk. We ondersteunen jouw ambitie voor interne en externe
          opleidingen. Een modern nieuw ingericht kantoor en een familiale sfeer
          zorgen voor een aangename werkomgeving.
          <p>Interesse? Neem gerust contact op via  <a href="mailto:kris@acensus.be">kris@acensus.be</a> </p>

          
        </div>
      )}
    </>
  );
}
